export class AwsNeptuneResource {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "dbClusterIdentifier",
            "baseName": "dbClusterIdentifier",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "string",
            "format": ""
        },
        {
            "name": "engine",
            "baseName": "engine",
            "type": "string",
            "format": ""
        },
        {
            "name": "engineVersion",
            "baseName": "engineVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "endpoint",
            "baseName": "endpoint",
            "type": "string",
            "format": ""
        },
        {
            "name": "port",
            "baseName": "port",
            "type": "number",
            "format": ""
        },
        {
            "name": "readerEndpoint",
            "baseName": "readerEndpoint",
            "type": "string",
            "format": ""
        },
        {
            "name": "storageEncrypted",
            "baseName": "storageEncrypted",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "kmsKeyId",
            "baseName": "kmsKeyId",
            "type": "string",
            "format": ""
        },
        {
            "name": "instanceCount",
            "baseName": "instanceCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "deletionProtection",
            "baseName": "deletionProtection",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "iamDbAuthenticationEnabled",
            "baseName": "iamDbAuthenticationEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "enabledCloudwatchLogsExports",
            "baseName": "enabledCloudwatchLogsExports",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsNeptuneResource.attributeTypeMap;
    }
    constructor() {
    }
}
